var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomerTable(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Background_2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.585083,
    y: 0.226562,
    width: 42.2979,
    height: 42.2979,
    fill: "#42D27B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.585083,
    y: 0.226562,
    width: 42.2979,
    height: 42.2979,
    fill: "white",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Overlay",
    x: 4.69733,
    y: 4.33984,
    width: 34.0733,
    height: 34.0733,
    rx: 17.0366,
    fill: "white",
    fillOpacity: 0.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerTable);
export default __webpack_public_path__ + "static/media/customer_table.c692da147f2ad838812bd909f2c6ec6e.svg";
export { ForwardRef as ReactComponent };